import { pipe } from 'ramda';
import { WidgetState } from 'components/organisms/projects-report/widgets';
import { Content } from 'stores/core';
import { UsersReportRecord, UsersReport } from '../../types';
import { getTopNBilliableUtlization } from './billable-utilization';
import { getTopNComments } from './collaboration';
import { getTopNTaskOnTimeCompletionPercentage } from './task-on-time-completion';

export type WidgetStateError = 'error';

interface Result {
  topTaskOnTimeCompletion: WidgetState<UsersReportRecord[], WidgetStateError>;
  topBillableUtilization: WidgetState<UsersReportRecord[], WidgetStateError>;
  topComments: WidgetState<UsersReportRecord[], WidgetStateError>;
}

export const useWidgetData = (usersReport: UsersReport): Result => {
  const records = pipe(
    () => usersReport,
    Content.map((x) => x),
    Content.orElse([] as UsersReportRecord[]),
  )();

  return {
    topTaskOnTimeCompletion: getTopNTaskOnTimeCompletionPercentage(records),
    topBillableUtilization: getTopNBilliableUtlization(records),
    topComments: getTopNComments(records),
  };
};
